import { VISITOR_CUSTOM_FIELD_TYPE_VALUES } from 'constants-visitor-management';
import { VisitorCustomFieldType } from 'graphql-query-contracts';

import type { CustomFieldTypeDefinition } from './customField.types';

export { isVisitorCustomFieldSelectType } from 'constants-visitor-management';

export const VISITOR_CUSTOM_FIELD_TYPE_VALUE_I18N_KEY_PREFIX =
  'web.admin.content.features.visitor.management.general.customFields.fieldTypeValue.';

export const VISITOR_CUSTOM_FIELD_TYPE_DEFINITIONS: readonly CustomFieldTypeDefinition[] = [
  {
    value: VisitorCustomFieldType.Text,
    labelKey: `${VISITOR_CUSTOM_FIELD_TYPE_VALUE_I18N_KEY_PREFIX}${VISITOR_CUSTOM_FIELD_TYPE_VALUES.TEXT}`,
  },
  {
    value: VisitorCustomFieldType.SelectDropdown,
    labelKey: `${VISITOR_CUSTOM_FIELD_TYPE_VALUE_I18N_KEY_PREFIX}${VISITOR_CUSTOM_FIELD_TYPE_VALUES.SELECT_DROPDOWN}`,
  },
  {
    value: VisitorCustomFieldType.SelectRadio,
    labelKey: `${VISITOR_CUSTOM_FIELD_TYPE_VALUE_I18N_KEY_PREFIX}${VISITOR_CUSTOM_FIELD_TYPE_VALUES.SELECT_RADIO}`,
  },
  {
    value: VisitorCustomFieldType.MultiSelect,
    labelKey: `${VISITOR_CUSTOM_FIELD_TYPE_VALUE_I18N_KEY_PREFIX}${VISITOR_CUSTOM_FIELD_TYPE_VALUES.MULTI_SELECT}`,
  },
];

export const VISITOR_CUSTOM_FIELD_TYPES_WITH_PLACEHOLDER = [
  VisitorCustomFieldType.Text,
] as const;

const VISITOR_CUSTOM_FIELD_TYPES_WITH_PLACEHOLDER_SET = new Set<VisitorCustomFieldType>(
  VISITOR_CUSTOM_FIELD_TYPES_WITH_PLACEHOLDER
);

export function isVisitorCustomFieldPlaceholderSupported(
  fieldType: VisitorCustomFieldType
): boolean {
  return VISITOR_CUSTOM_FIELD_TYPES_WITH_PLACEHOLDER_SET.has(fieldType);
}

export function getVisitorCustomFieldTypeLabelKey(
  fieldType: VisitorCustomFieldType
): string | undefined {
  return VISITOR_CUSTOM_FIELD_TYPE_DEFINITIONS.find(d => d.value === fieldType)?.labelKey;
}

/**
 * Maps a UI string (e.g. Dropdown `onValueChange`) to a known field type, defaulting to the first configured type.
 */
export function coerceVisitorCustomFieldTypeFromUi(value: string): VisitorCustomFieldType {
  const normalized = value.toLowerCase();
  const def = VISITOR_CUSTOM_FIELD_TYPE_DEFINITIONS.find(
    d => String(d.value).toLowerCase() === normalized
  );

  return def?.value ?? VISITOR_CUSTOM_FIELD_TYPE_DEFINITIONS[0].value;
}
